"use strict";
import Splide from "@splidejs/splide";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const benefitsSlider = document.querySelector(
            ".o-benefits__items.splide"
        );
        if (!benefitsSlider) return;

        const splide = new Splide(benefitsSlider, {
            type: "loop",
            perPage: 4,
            autoplay: false,
            interval: 5000,
            speed: 800,
            drag: false,
            pauseOnHover: true,
            arrows: false,
            pagination: false,
            gap: "2.25rem",
            breakpoints: {
                1024: {
                    perPage: 3,
                    drag: true,
                },
                680: {
                    perPage: 1,
                },
            },
        });

        splide.mount();
    });
}
